import {DashboardScreenProps} from '../DashboardScreenProps';
import {WorkerOrder} from '../types';

export default (
  params: DashboardScreenProps['route']['params'],
  groupId: number,
): WorkerOrder =>
  params?.groupOptionsById?.[groupId]?.workerOrder ?? WorkerOrder.Default;
